module.exports = __webpack_public_path__ + "img/cd.1bfcb589.jpg";